import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetActiveProjects } from '../selectors/projects';

import { logError } from 'shared-services/logger-service';

import mdRules from './md-rules';
import mdParse from '../md/parser';

class NiftyMarkdown extends PureComponent {
    static defaultProps = {
        withContainer: true
    }

    loadRaw = false;

    get content() {
        if (!this.props.children) {
            return null;
        }

        if (this.loadRaw) {
            return this.props.children;
        }

        try {
            if (typeof this.props.children === 'object') {
                return mdParse(this.props.children[0], mdRules, null, this.props.projectNiceIds, this.props.disabledRules);
            }

            return mdParse(this.props.children, mdRules, null, this.props.projectNiceIds, this.props.disabledRules);
        } catch (e) {
            logError('markdown', e, {
                text: this.props.children
            });
            return this.props.children;
        }
    }

    componentDidCatch(error, info) {
        this.loadRaw = true;

        logError('markdown', error, {
            text: this.props.children
        });

        this.forceUpdate();
    }

    render() {
        if (this.props.withContainer) {
            return (
                <div className={this.props.unstyled ? 'nifty-md-unstyled' : 'nifty-md'} placeholder={this.props.placeholder}>{ this.content }</div>
            )
        }

        return this.content;
    }
}

const makeMapStateToProps = () => {
    const getActiveProjects = makeGetActiveProjects();

    return ({ projects }) => ({
        projectNiceIds: getActiveProjects(projects.items).map(p => p.nice_id).join('|')
    });
}

export default connect(makeMapStateToProps)(NiftyMarkdown);
